<template>
  <div>
    <!-- TITLE -->
    <h1 class="h3">Gerenciar Credenciais</h1>
    <!-- // TITLE -->

    <div class="row">
      <div class="col-sm-6">
        <!-- AUTOCOMPLETE -->
        <select-autocomplete
          v-model="company"
          :name="`company-autocomplete`"
          :placeholder="`Busque uma empresa por nome fantasia, razão social ou cnpj`"
          :loading="companies.loading"
          :list="companies.list"
          :listKey="'name'"
          :selectedValue="company"
          ico="fa-building"
          @event="handleCompanies" />
        <!-- // AUTOCOMPLETE -->
      </div>
      <div class="col-sm-6">
        <!-- AUTOCOMPLETE -->
        <select-autocomplete
          v-model="provider"
          :name="`provider-autocomplete`"
          :placeholder="`Busque um Provider`"
          :loading="providers.loading"
          :list="providers.list"
          :listKey="'name'"
          :disabled="disabled"
          :error="providers.error"
          :selectedValue="provider"
          :imageKey="'slug'"
          :imagePath="'img/providers'"
          ico="fa-key">
          <template v-slot:image="{ imageSrc }">
            <provider-image
              :imageSrc="imageSrc" />
          </template>
        </select-autocomplete>
        <!-- // AUTOCOMPLETE -->
      </div>
    </div>

    <!-- HISTORY -->
    <providers-history
      v-if="company && company.providersRelated.length"
      :history="company.providersRelated"
      @handleAction="handleHistoryAction" />
    <!-- // HISTORY -->

    <!-- ALERT -->
    <alert-helper
      :alert="alert"
      :type="alertType"
      :close="true"
      class="_mt-10" />
    <!-- // ALERT -->

    <div
      v-if="provider && form.fields.length"
      class="mt-20">
      <h3 class="h3 _mt-0 _mb-0 title-manage-account">
        Provider
        <span class="breadcrumbs-arrow">
          <provider-image
            :imageSrc="provider.slug"
            class="small-img" />
          {{ provider.name }}
        </span>
      </h3>
      <!-- ALERT -->
      <alert-helper
        v-if="form.status.length"
        :alert="`Status ${form.status} ${form.status_details}`"
        :type="status[form.status]"
        :close="true"
        class="_mt-10" />
      <!-- // ALERT -->
      <!-- FORM -->
      <provider-form
        v-if="form.fields.length"
        :formFields="form.fields"
        :active="form.active"
        :loading="loading"
        @handleAction="handleProviderManage" />
      <!-- // FORM -->
    </div>

    <lock-screen :loading="loading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ProviderForm from '@/views/dashboard/providers/ProviderForm'
import ProvidersHistory from '@/views/dashboard/providers/ProvidersHistory'
import ProviderImage from '@/views/dashboard/providers/ProviderImage'
import SelectAutocomplete from '@/components/fields/SelectAutocomplete'
import AlertHelper from '@/components/ui/AlertHelper'
import LockScreen from '@/components/lockscreen/index.vue'
import { ProviderManage as Model } from '@/models/ProviderManage'

const initialForm = { fields: [], active: false, status: '', status_details: '' }

export default {
  components: {
    ProviderForm,
    ProvidersHistory,
    ProviderImage,
    SelectAutocomplete,
    AlertHelper,
    LockScreen
  },
  data () {
    return {
      companies: { ...Model },
      providers: { ...Model },
      company: null,
      provider: null,
      form: { ...initialForm },
      loading: false,
      alert: null,
      alertType: 'danger',
      status: {
        'VALID': 'success',
        'INVALID': 'danger',
        'PENDING': 'warning'
      }
    }
  },
  mounted () {
    this.handleProviders()
  },
  watch: {
    'company' (data) {
      if (data) {
        if (!Object.prototype.hasOwnProperty.call(data, 'providersRelated')) {
          this.handleCompany(data)
        }

        if (this.provider) {
          /**/
          this.handleProviderFields({
            companyId: this.company.id,
            providerId: this.provider.id
          })
        }
      }
    },
    'provider' (data) {
      if (data && this.company) {
        /**/
        this.handleProviderFields({
          companyId: this.company.id,
          providerId: this.provider.id
        })
      }
    }
  },
  computed: {
    disabled () {
      return this.company === null
    }
  },
  methods: {
    ...mapActions('companies', [
      'getAdminCompanies',
      'getAdminCompany'
    ]),
    ...mapActions('providers', [
      'getAdminProviders',
      'getAdminProviderManage',
      'postAdminProviderManage'
    ]),
    handleProviders () {
      this.providers.loading = true

      this.getAdminProviders()
        .then(response => {
          this.providers.loading = false
          this.providers.list = response
        })
        .catch(error => {
          this.providers.loading = false
          this.providers.error = error
        })
    },
    handleCompany (company) {
      this.$set(this.company, 'providersRelated', [])

      this.getAdminCompany(company.document_number.replace(/[^\w\s]/gi, ''))
        .then(response => {
          this.$set(this.company, 'providersRelated', response.providers_related)
        }).catch(error => {
          this.alertType = 'danger'
          this.alert = error
        })
    },
    handleCompanies (search) {
      this.companies.error = false
      this.companies.loading = true

      this.getAdminCompanies({ search, ordering: 'name' })
        .then(response => {
          this.companies.loading = false
          this.companies.list = response.results
        })
        .catch(error => {
          this.companies.loading = false
          this.companies.error = error
        })
    },
    handleProviderFields ({ companyId, providerId }) {
      this.alert = null
      this.alertType = 'danger'
      this.loading = true
      this.form = { ...initialForm }

      this.getAdminProviderManage({ companyId, providerId })
        .then(response => {
          this.form.status = response.status
          this.form.status_details = response.status_details
          this.form.fields = response.fields
          this.form.active = response.active
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.alert = error
        })
    },
    handleProviderManage (fields) {
      this.alert = null
      this.loading = true

      this.postAdminProviderManage({
        provider: this.provider.id,
        company_id: this.company.id,
        fields
      })
        .then(response => {
          this.loading = false
          this.alertType = 'success'
          this.alert = response

          this.handleReset()
          this.handleCompany(this.company)
        })
        .catch(error => {
          this.loading = false
          this.alertType = 'danger'
          this.alert = error
        })
    },
    handleReset () {
      const { list } = this.providers
      this.providers = {
        ...Model,
        list: [...list]
      }
      this.companies = { ...Model }
      this.form = { ...initialForm }
      this.provider = null
    },
    handleHistoryAction (id) {
      const provider = this.providers.list.filter(item => item.id === id)[0]
      if (provider) {
        this.provider = provider
      }
    }
  }
}
</script>
